/* tslint:disable */
import {
  CompanyAccount,
  ChartOfAccount,
  UserProfile
} from '../index';

declare var Object: any;
export interface ExpenditureInterface {
  "management_company_id"?: number;
  "quantity"?: string;
  "amount": number;
  "witholding_tax_amount": number;
  "date_incurred": Date;
  "due_date"?: Date;
  "payment_status": string;
  "chart_of_account_id": number;
  "description"?: string;
  "invoice_no"?: string;
  "property_id": number;
  "date_paid"?: Date;
  "tag"?: string;
  "doc_status"?: string;
  "id"?: number;
  "vendor_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  property?: CompanyAccount;
  chartOfAccount?: ChartOfAccount;
  vendors?: UserProfile;
}

export class Expenditure implements ExpenditureInterface {
  "management_company_id": number;
  "quantity": string;
  "amount": number;
  "witholding_tax_amount": number;
  "date_incurred": Date;
  "due_date": Date;
  "payment_status": string;
  "chart_of_account_id": number;
  "description": string;
  "invoice_no": string;
  "property_id": number;
  "date_paid": Date;
  "tag": string;
  "doc_status": string;
  "id": number;
  "vendor_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  property: CompanyAccount;
  chartOfAccount: ChartOfAccount;
  vendors: UserProfile;
  constructor(data?: ExpenditureInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Expenditure`.
   */
  public static getModelName() {
    return "Expenditure";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Expenditure for dynamic purposes.
  **/
  public static factory(data: ExpenditureInterface): Expenditure{
    return new Expenditure(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Expenditure',
      plural: 'Expenditures',
      path: 'Expenditures',
      idName: 'id',
      properties: {
        "management_company_id": {
          name: 'management_company_id',
          type: 'number'
        },
        "quantity": {
          name: 'quantity',
          type: 'string'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "witholding_tax_amount": {
          name: 'witholding_tax_amount',
          type: 'number',
          default: 0
        },
        "date_incurred": {
          name: 'date_incurred',
          type: 'Date'
        },
        "due_date": {
          name: 'due_date',
          type: 'Date'
        },
        "payment_status": {
          name: 'payment_status',
          type: 'string'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "invoice_no": {
          name: 'invoice_no',
          type: 'string'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "date_paid": {
          name: 'date_paid',
          type: 'Date'
        },
        "tag": {
          name: 'tag',
          type: 'string'
        },
        "doc_status": {
          name: 'doc_status',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "vendor_id": {
          name: 'vendor_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_account_id',
          keyTo: 'id'
        },
        vendors: {
          name: 'vendors',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'vendor_id',
          keyTo: 'id'
        },
      }
    }
  }
}
